export default __webpack_public_path__ + "locales/es/Settings.json?hash=c8f5cb8f518b188313c7d3f1a0ec39a4";